export const T = {
  en_GB: {
    gridTitle: "Dynamic Portfolios — Grid",
    gridDescription:
      "Edit weights for each product across risk-score dynamic portfolios. Each column must total 100%.",
    columnTitle: "Dynamic portfolio",
    noDynamicPortfolio: "No dynamic portfolio yet",
    noPlatform: "No platform",
    notAddable: "This product is not available on the platforms of this dynamic portfolio",
  },
  nb_NO: {
    gridTitle: "Dynamiske porteføljer — Rutenett",
    gridDescription:
      "Rediger vekt for hvert produkt på tvers av dynamiske porteføljer per risikoscore. Hver kolonne må summere til 100%.",
    columnTitle: "Dynamisk portefølje",
    noDynamicPortfolio: "Ingen dynamisk portefølje ennå",
    noPlatform: "Ingen plattform",
    notAddable:
      "Dette produktet er ikke tilgjengelig på plattformene til denne dynamiske porteføljen",
  },
} as const;
